import React,{Fragment} from 'react';
import {formatExistingOrderDateTimeOnly,formatExistingOrderDateTime,isDateMatches} from '../../../../../utils/general';
import NewTabletRenderDeliveryType from './NewTabletRenderDeliveryType';
const NewTabletOrderItem = (props) => {


        // console.log('props in OrderItem')
        // console.log(props)
        return (
                <tr className="cursor-pointer" onClick={()=> props.handelOnClickTabletNewOrder(props)}>
                    <td>
                        <NewTabletRenderDeliveryType   
                            selectedOrderType={props.delivery_type}
                        />
                    </td>
                    <td>
                        {props.fullname}
                    </td>
                    <td>
                        {/* {formatExistingOrderDateTime(props.order_completion_datetime)} <br /> */}
                        {/* {formatExistingOrderDate(props.order_completion_datetime)}<br /> */}
                        {formatExistingOrderDateTimeOnly(props.order_completion_datetime)} <br />
                        {
                                isDateMatches(props.order_completion_datetime,new Date()) === false ?
                                    <Fragment> {formatExistingOrderDateTime(props.order_completion_datetime)} </Fragment>
                                :null
                            }

                    </td>
                    <td>
                        ${props.final_total}
                    </td>
                    
                </tr>
        );
}



export default NewTabletOrderItem;